import { MenuType } from "@src/pages/UploadMenuPage/generator";
import { menusApi } from "@src/service/menus";
import { getRequestError } from "@src/utils/getRequestError";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { setGlobalLoader, setSnackbar } from "../generals/actionCreators";
import { LoadingStatus } from "../generals/types";
import { getMatchMenuProducts, parseMenuSuccess } from "./reducer";
import {
  GET_MATCH_MENU_PRODUCTS_SAGA,
  GET_MATCH_MENU_PRODUCTS_SUCCESS,
  GET_MATCH_MENU_SECTIONS_SAGA,
  GET_MATCH_MENU_SECTIONS_SUCCESS,
  IS_MATCHED_ALL_SAGA,
  PARSE_MENU_ERROR,
  PARSE_MENU_FETCH,
  PARSE_MENU_SAGA,
  PARSE_MENU_SUCCESS,
  UPLOAD_MENU_SAGA,
  UPLOAD_EXPRESS_MENU_SAGA,
} from "./types/actionTypes";

export function* parseMenuRequest(action: any) {
  try {
    yield put({ type: PARSE_MENU_FETCH });
    const { data } = yield call(menusApi.parseMenu, action.payload);
    if (data.data) {
      yield put(parseMenuSuccess(data.data));
    } else {
      yield put(
        setSnackbar({
          visible: true,
          message: "wrong file loaded",
          status: "error",
        })
      );
    }
  } catch (e) {
    yield put({ type: PARSE_MENU_ERROR });
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}

export function* uploadMenuRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { navigate, menuType, ...rest } = action.payload;
    if (menuType === MenuType.GLOVO) {
      yield call(menusApi.createMenu, JSON.stringify(rest));
    } else if (menuType === MenuType.WOLT) {
      yield call(menusApi.uploadMenuWolt, JSON.stringify(rest));
    } else if (menuType === MenuType.YANDEX) {
      yield call(menusApi.uploadMenuYandex, JSON.stringify(rest));
    }
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
    navigate(`/app/menu`);
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}

export function* uploadExpressMenuRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { navigate, ...rest } = action.payload;
    yield call(menusApi.uploadExpressMenu, rest);
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
    navigate(`/app/menu`);
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}

export function* getMatchMenuProductsRequest(action: any) {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    const { menu_id, restaurant_id, section_name, page, field } =
      action.payload;
    const { data } = yield call(menusApi.getMenuProductsForMatching, {
      menuId: menu_id,
      restaurantId: restaurant_id,
      sectionId: section_name,
      page: page,
    });
    yield put({
      type: GET_MATCH_MENU_PRODUCTS_SUCCESS,
      payload: { ...data, section_name },
    });
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}

export function* matchingProductRequest(action: any) {
  try {
    // const { menu_id, aggregator_product_id, pos_product_id, section, page } = action.payload;
    // const { data } = yield call(menusApi.matchingPorduct, menu_id, aggregator_product_id, pos_product_id);
    // IF VSE IS OK THEN GET PRODUCTS AGAIN
    // yield put({ type: MATCH_MENU_SUCCESS, payload: aggregator_product_id });
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}
export function* checkAllMatchedRequest(action: any) {
  try {
    const { currLocation } = yield select((state) => state.appManager);
    const { data } = yield call(menusApi.isMatchedAll, action.payload.menuId, {
      restaurant_id: currLocation,
    });
    yield put(
      setSnackbar({
        visible: true,
        message: "All products matched",
        status: "success",
      })
    );
    action.payload.navigate("/app/createMenu/success");
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        message: getRequestError(e),
        status: "error",
      })
    );
  }
}

export function* createMenuSagas() {
  yield takeLatest(PARSE_MENU_SAGA, parseMenuRequest);
  yield takeLatest(UPLOAD_MENU_SAGA, uploadMenuRequest);
  yield takeLatest(UPLOAD_EXPRESS_MENU_SAGA, uploadExpressMenuRequest);
  yield takeLatest(GET_MATCH_MENU_PRODUCTS_SAGA, getMatchMenuProductsRequest);
  yield takeLatest(IS_MATCHED_ALL_SAGA, checkAllMatchedRequest);
}
